import { Link } from "react-router-dom";
import { ExternalLink, Info } from "lucide-react";
import { api, formatPrice, BADGES } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export const ProductCard = ({ product, index = 0 }) => {
  const badge = product.badge ? BADGES[product.badge] : null;
  const track = () => api.post(`/products/${product.id}/click`).catch(() => {});

  return (
    <Reveal delay={(index % 4) * 0.07} className="h-full">
      <article
        data-testid={`product-card-${product.id}`}
        className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 transition-[box-shadow,transform] duration-300 flex flex-col h-full"
      >
        <Link
          to={`/producto/${product.id}`}
          data-testid={`product-detail-link-${product.id}`}
          className="relative block h-44 bg-slate-100 overflow-hidden group"
        >
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-2 left-2 flex flex-col gap-1 items-start">
            {badge && (
              <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-md border ${badge.cls}`}>
                {badge.label}
              </span>
            )}
            {product.provisional && (
              <span className="text-[10px] font-semibold uppercase tracking-wider px-2 py-1 rounded-md bg-slate-900/80 text-white">
                Muestra
              </span>
            )}
          </div>
        </Link>

        <div className="p-4 flex flex-col flex-1">
          <Link to={`/producto/${product.id}`} data-testid={`product-name-link-${product.id}`}>
            <h3 className="font-display font-semibold text-slate-900 text-base leading-snug line-clamp-2 hover:text-amber-600 transition-colors">
              {product.name}
            </h3>
          </Link>

          {product.problem && (
            <p className="bg-slate-50 border-l-2 border-amber-500 px-2.5 py-2 text-xs text-slate-600 italic mt-3 rounded-r-md line-clamp-2">
              {product.problem}
            </p>
          )}

          <div className="mt-auto pt-4">
            {product.price != null && (
              <p className="font-display text-xl font-bold text-slate-900 mb-3" data-testid={`product-price-${product.id}`}>
                {formatPrice(product.price)}
              </p>
            )}
            {product.amazon_url ? (
              <a
                href={product.amazon_url}
                target="_blank"
                rel="noopener noreferrer sponsored"
                onClick={track}
                data-testid={`buy-amazon-${product.id}`}
                className="w-full bg-amber-500 hover:bg-amber-400 active:scale-[0.98] text-slate-950 font-bold py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-[background-color,transform] text-sm shadow-sm"
              >
                Comprar <ExternalLink size={14} strokeWidth={2.5} />
              </a>
            ) : (
              <span className="w-full bg-slate-100 text-slate-400 font-semibold py-2.5 px-4 rounded-lg flex items-center justify-center gap-2 text-sm cursor-not-allowed" data-testid={`buy-pending-${product.id}`}>
                <Info size={14} /> Enlace disponible próximamente
              </span>
            )}
          </div>
        </div>
      </article>
    </Reveal>
  );
};
